import { createFileRoute, redirect } from "@tanstack/react-router";
import { SignIn } from "@/features/auth/sign-in";
import { authClient, NO_AUTH, safeRedirect } from "@/lib/auth-client";

export const Route = createFileRoute("/sign-in")({
  validateSearch: (s) => ({ redirect: typeof s.redirect === "string" ? s.redirect : undefined }),
  beforeLoad: async ({ search }) => {
    if (NO_AUTH) throw redirect({ to: "/" });
    const { data } = await authClient.getSession().catch(() => ({ data: null }));
    if (data?.session) throw redirect({ href: safeRedirect(search.redirect) });
  },
  component: SignIn,
});

